var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24DE1615-80C6-48A8-B964-52D5B862D1C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-279.000000, -1064.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(279.000000, 1064.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.279452, 17.000000)",
    id: "np_One-of-the-most-deadly-poisonous-plants-in-the-US-to-both-humans-and-animals,-Bulblet-Bearing-Water_47pzPb_free"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.279452055,0 L69.7205479,0 L69.7205479,70 C68.1709259,69.4158043 66.401568,68.9731008 64.5464893,68.6542634 L64.5464893,65.2650937 C64.7015168,65.2064138 64.8434559,65.2005451 64.9932622,65.1307804 C65.2850042,65.2357537 65.5865591,65.3237653 65.8979103,65.3237653 C67.3958553,65.3237653 68.6224211,64.1012607 68.6224211,62.6075891 C68.6224211,61.4581089 67.8315761,60.5512201 66.7797341,60.1658179 C66.7915083,60.0784489 66.8150573,59.9786916 66.8150573,59.8913293 C66.8150573,58.397591 65.5885753,57.186837 64.0905465,57.186837 C62.5925177,57.186837 61.3660357,58.4086907 61.3660357,59.9025125 C61.3666898,59.9898815 61.3895834,60.0779048 61.4013589,60.1652671 C60.4620306,60.5101762 59.8190327,61.3114924 59.6732119,62.2875666 C59.551545,62.2171494 59.4743578,62.0945818 59.3415651,62.0482801 C59.3474522,61.9726484 59.3651128,61.8963625 59.3651128,61.8207275 C59.3651128,60.5630042 58.3374849,59.5386921 57.075653,59.5386921 C55.813821,59.5386921 54.7861931,60.5636385 54.7861931,61.8207275 C54.7868472,61.8963591 54.7979675,61.9726451 54.8097408,62.0482801 C53.9247018,62.3755799 53.2535712,63.1351679 53.2529182,64.1014777 C53.2529182,65.359201 54.2923182,66.383513 55.5540999,66.383513 C55.8170562,66.383513 56.0623627,66.3130958 56.3096116,66.2257285 C56.4345489,66.2844084 56.5699556,66.2844084 56.6988131,66.3365687 L56.6988131,68.0480953 C55.2348784,68.0480953 53.8847133,68.1941442 52.6346535,68.3812704 C52.1506049,67.0961734 51.5638554,65.8358462 50.8378495,64.6844799 L48.5483897,61.0561238 L38.8183528,45.6296848 C36.6414235,42.1864352 33.1307063,42.1864352 30.953777,45.6296848 L27.8054348,50.6272288 L19.5980763,37.6196938 C17.421147,34.1764443 13.9221517,34.1764443 11.7452224,37.6196938 L-0.274274312,56.674489 L-0.279452055,0 Z M53.7150231,8 L53.7143399,8 C51.0625261,8.00204841 48.5200095,9.05687351 46.6462173,10.9322733 C44.7724251,12.8076555 43.7198488,15.3494714 43.7205479,18 C43.7198652,20.6503538 44.77253,23.1928688 46.6462173,25.0677268 C48.520709,26.943109 51.0625261,27.9980771 53.7143399,28 C56.3682522,28.0006824 58.9133919,26.9479155 60.7906816,25.0724458 C62.6670969,23.1970635 63.7212471,20.6524512 63.7205479,18 C63.7212308,15.3475488 62.6672018,12.8038104 60.7906816,10.9282533 C58.9142662,9.05287106 56.3682522,7.99930123 53.7143399,8 L53.7150231,8 Z M61.4664601,64 C61.9634991,64.3278212 62.5301703,64.5670011 63.177567,64.5670011 C63.531644,64.5670011 63.8820043,64.4727339 64.2146152,64.358779 C64.3827639,64.422092 64.5472072,64.4284241 64.7205479,64.5036971 L64.7205479,68 C62.3968225,67.6721788 60.0035029,67.5209197 57.7205479,67.5209197 L57.7205479,65.674258 C57.8679549,65.6109449 58.0183239,65.6109449 58.1612859,65.5546662 C58.4398143,65.6489335 58.719803,65.7249088 59.0168393,65.7249088 L59.0301728,65.7249088 C60.1798044,65.7249088 61.1278593,64.9890716 61.4672969,64.0013759 L61.4664601,64 Z",
    id: "Shape",
    fill: "#979797",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.e765042dc81932819c88da348e7441de.svg";
export { ForwardRef as ReactComponent };